import { render } from "./AIInterface.vue?vue&type=template&id=9cc57260&scoped=true"
import script from "./AIInterface.vue?vue&type=script&lang=ts"
export * from "./AIInterface.vue?vue&type=script&lang=ts"

import "./AIInterface.vue?vue&type=style&index=0&id=9cc57260&lang=scss"
import "./AIInterface.vue?vue&type=style&index=1&id=9cc57260&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9cc57260"

export default script